module.exports = __webpack_public_path__ + "img/bootstrap.e9fcb24d.png";